import {
  METRIC_DEFINITIONS,
  getMetricUnit,
} from "../../../../../shared/utils/metricDefinitions";
import type { ChartKind, Granularity } from "../api/types";

/** Metrics offerable in a chart block, drawn from the canonical definitions. */
export const METRIC_OPTIONS = Object.entries(METRIC_DEFINITIONS).map(
  ([id, def]) => ({
    id,
    label: def.plainName,
    unit: getMetricUnit(id),
  }),
);

export const metricLabel = (id: string): string =>
  METRIC_DEFINITIONS[id]?.plainName ?? id;

export const CHART_KIND_OPTIONS: { value: ChartKind; label: string }[] = [
  { value: "line", label: "Line" },
  { value: "verticalBar", label: "Vertical bars" },
  { value: "horizontalBar", label: "Horizontal bars" },
  { value: "donut", label: "Donut (distribution)" },
];

export const GRANULARITY_OPTIONS: { value: Granularity; label: string }[] = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
];

export const WINDOW_OPTIONS: { value: number; label: string }[] = [
  { value: 30, label: "Last 30 days" },
  { value: 90, label: "Last 90 days" },
  { value: 180, label: "Last 6 months" },
  { value: 365, label: "Last 12 months" },
];
